"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Transition = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var defaults_1 = require("../animations/defaults");
var types_1 = require("./animation-hooks/types");
var animation_hooks_1 = require("./animation-hooks");
exports.Transition = function (props) {
    var _a = react_1.useState(null), transitionState = _a[0], setTransitionState = _a[1];
    var children = props.children, inViewRef = props.inViewRef, disabled = props.disabled;
    var prevChildren = react_1.useRef(props.animateOnMount ? null : children);
    var containerRef = react_1.useRef(null);
    var unmounted = react_1.useRef(false);
    var hasChildrenChanged = didChildrenChanged(prevChildren.current, children);
    if (!hasChildrenChanged && !transitionState) {
        prevChildren.current = children;
    }
    react_1.useEffect(function () { return function () { return unmounted.current = true; }; }, []);
    // start exit transition if children changed
    react_1.useEffect(function () {
        if (!hasChildrenChanged) {
            return;
        }
        if (!transitionState) {
            setTransitionState(types_1.TransitionState.Exit);
        }
    });
    var udpatedState = function (state) {
        if (!unmounted.current) {
            setTransitionState(state);
        }
    };
    var animationHooks = {
        children: children,
        element: containerRef.current,
        prevChildren: prevChildren.current,
        transitionState: transitionState,
        disabled: disabled,
        onFinish: null,
    };
    var _b = animation_hooks_1.useContainerRectangle(tslib_1.__assign(tslib_1.__assign({}, animationHooks), { onFinish: function () { return udpatedState(types_1.TransitionState.Container); } })), nextClientRect = _b.nextClientRect, prevClientRect = _b.prevClientRect;
    animation_hooks_1.useExitAnimation(tslib_1.__assign(tslib_1.__assign({}, animationHooks), { prevClientRect: prevClientRect, settings: props.exitAnimation, onFinish: function () {
            var hadPrevChildren = !!prevChildren.current;
            prevChildren.current = children;
            if (hadPrevChildren && prevChildren.current) {
                props.onExitFinished && props.onExitFinished();
            }
            udpatedState(types_1.TransitionState.ContainerRect);
        } }));
    animation_hooks_1.useContainerAnimation(tslib_1.__assign(tslib_1.__assign({}, animationHooks), { prevClientRect: prevClientRect,
        nextClientRect: nextClientRect, animateContainer: props.animateContainer, animateContainerDuration: props.animateContainerDuration, animateContainerEasing: props.animateContainerEasing, onFinish: function () {
            if (!prevChildren.current) {
                props.onExitFinished && props.onExitFinished();
            }
            udpatedState(types_1.TransitionState.Enter);
        } }));
    animation_hooks_1.useEnterAnimation(tslib_1.__assign(tslib_1.__assign({}, animationHooks), { nextClientRect: nextClientRect, settings: props.enterAnimation, onFinish: function () {
            if (prevChildren.current) {
                props.onEnterFinished && props.onEnterFinished();
            }
            udpatedState(null);
        } }));
    var shouldRenderPrevChildren = hasChildrenChanged || transitionState === types_1.TransitionState.Exit;
    var hideContent = transitionState === types_1.TransitionState.Container;
    var setRefs = react_1.useCallback(function (element) {
        containerRef.current = element;
        inViewRef && inViewRef(element);
    }, [inViewRef]);
    if (!hasChildrenChanged && !transitionState && !children) {
        return null;
    }
    return (react_1.default.createElement("div", { ref: setRefs, className: classnames_1.default(props.className, transitionState === types_1.TransitionState.Enter && props.classNameEnter, transitionState === types_1.TransitionState.Exit && props.classNameExit) || null, style: tslib_1.__assign(tslib_1.__assign({}, props.style), { opacity: hideContent ? 0 : null }) }, shouldRenderPrevChildren ?
        prevChildren.current :
        children));
};
var didChildrenChanged = function (prevChildren, children) {
    var prevChildrenElement = prevChildren;
    var childrenElement = children;
    if (!prevChildren && !children) {
        return false;
    }
    if (!prevChildren && children) {
        return true;
    }
    if (prevChildren && !children) {
        return true;
    }
    if (prevChildrenElement.key === childrenElement.key &&
        prevChildrenElement.type === childrenElement.type) {
        return false;
    }
    return true;
};
exports.Transition.defaultProps = {
    animateContainer: false,
    animateContainerDuration: defaults_1.defaultTransitionDuration,
    animateContainerEasing: defaults_1.defaultTransitionEasing,
};
exports.Transition.displayName = "Transition";
